
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function TransformIndex() {
  return (
    <NonFSIndex
      data_type="transform"
    />
  );
}
